var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/list.tsx";

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import classNames from 'clsx';
import * as React from 'react';
import { v4 as uuidv4 } from 'uuid';
import { SelectDropdown } from '../features/forms';
import Icon from './icon';
import { Select } from './ui';

const List = _ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement("div", {
    className: "space-y-0.5",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 11,
      columnNumber: 3
    }
  }, children);
};

const ListItem = _ref2 => {
  let {
    label,
    hint,
    children,
    onClick
  } = _ref2;
  const id = uuidv4();
  const domId = "list-group-".concat(id);

  const onKeyDown = e => {
    if (e.key === 'Enter') {
      onClick();
    }
  };

  const Comp = onClick ? 'a' : 'div';
  const LabelComp = onClick ? 'span' : 'label';
  const linkProps = onClick ? {
    onClick,
    onKeyDown,
    tabIndex: 0,
    role: 'link'
  } : {};
  const renderChildren = React.useCallback(() => {
    return React.Children.map(children, child => {
      if ( /*#__PURE__*/React.isValidElement(child)) {
        const isSelect = child.type === SelectDropdown || child.type === Select;
        return /*#__PURE__*/React.cloneElement(child, {
          id: domId,
          className: classNames({
            'w-auto': isSelect
          }, child.props.className)
        });
      }

      return null;
    });
  }, [children, domId]);
  return /*#__PURE__*/React.createElement(Comp, _extends({
    className: classNames({
      'flex items-center justify-between px-3 py-2 first:rounded-t-lg last:rounded-b-lg bg-gradient-to-r from-gradient-start/10 to-gradient-end/10': true,
      'cursor-pointer hover:from-gradient-start/20 hover:to-gradient-end/20 dark:hover:from-gradient-start/5 dark:hover:to-gradient-end/5': typeof onClick !== 'undefined'
    })
  }, linkProps, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 52,
      columnNumber: 5
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col py-1.5 pr-4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 59,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(LabelComp, {
    className: "text-gray-900 dark:text-gray-100",
    htmlFor: domId,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 60,
      columnNumber: 9
    }
  }, label), hint ? /*#__PURE__*/React.createElement("span", {
    className: "text-sm text-gray-700 dark:text-gray-600",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 63,
      columnNumber: 11
    }
  }, hint) : null), onClick ? /*#__PURE__*/React.createElement("div", {
    className: "flex flex-row items-center text-gray-700 dark:text-gray-600",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 9
    }
  }, children, /*#__PURE__*/React.createElement(Icon, {
    src: require('@tabler/icons/chevron-right.svg'),
    className: "ml-1",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 71,
      columnNumber: 11
    }
  })) : renderChildren());
};

export { List as default, ListItem };